import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { Severity } from "./interfaces";
import { LoggerService } from "../logger";
export var ErrorService = /*#__PURE__*/ function() {
    "use strict";
    function ErrorService() {
        _class_call_check(this, ErrorService);
        this.logger = new LoggerService();
    }
    var _proto = ErrorService.prototype;
    /**
   * Handle Errors
   */ _proto.handleError = function handleError(severity, errorDetail) {
        switch(severity){
            case Severity.HIGH:
                this.handleHighSeverity(errorDetail);
                break;
            case Severity.MEDIUM:
                this.handleMediumSeverity(errorDetail);
                break;
            case Severity.LOW:
            default:
                this.handleLowSeverity(errorDetail.message, errorDetail.errorCode);
        }
    };
    /**
   * Handle high severity error
   */ _proto.handleHighSeverity = function handleHighSeverity(errorDetail) {
        var detail = _object_spread_props(_object_spread({}, errorDetail), {
            severity: Severity.HIGH
        });
        this.customErrorEvent = new CustomEvent("errorServiceNotificationEvent", {
            detail: detail
        });
        document.dispatchEvent(this.customErrorEvent);
    };
    /**
   * Handle medium severity error
   */ _proto.handleMediumSeverity = function handleMediumSeverity(errorDetail) {
        var detail = _object_spread_props(_object_spread({}, errorDetail), {
            severity: Severity.MEDIUM
        });
        this.customErrorEvent = new CustomEvent("errorServiceNotificationEvent", {
            detail: detail
        });
        document.dispatchEvent(this.customErrorEvent);
    };
    /**
   * Handle low severity error
   */ _proto.handleLowSeverity = function handleLowSeverity(description, errorCode) {
        this.logger.warn("SEVERITY: ".concat(Severity.LOW, " | ERROR CODE: ").concat(errorCode, " | ").concat(description));
    };
    /**
   * Get Severity High
   */ ErrorService.getSeverityErrorHigh = function getSeverityErrorHigh() {
        return Severity.HIGH;
    };
    /**
   * Get severuty medium
   */ ErrorService.getSeverityErrorMedium = function getSeverityErrorMedium() {
        return Severity.MEDIUM;
    };
    /**
   * Get severity Low
   */ ErrorService.getSeverityErrorLow = function getSeverityErrorLow() {
        return Severity.LOW;
    };
    return ErrorService;
}();
